import React from "react";
import { useEffect, useState } from 'react';
import ReactSpeedometer from "react-d3-speedometer"
import { Card, CardHeader } from "reactstrap";
import {CardBody} from "reactstrap";
import './Miniwidget.css'
import { apiEndpoint } from "helpers/url_helper";

var speedoMeterProps=[];
const Speedometer= props =>  {
    const [todaysMaxSpeed, settodaysMaxSpeed] = useState([]);
    const [monthlyMaxSpeed, setmonthlyMaxSpeed] = useState([]);
    const [todaysAvgSpeed, settodaysAvgSpeed] = useState([]);
    const [bounce, setbounce] = useState(false);
    const [monthlyViolationDetails, setMonthlyViolationDetails] = useState(null);
    const [TodaysViolationDetails, setTodaysViolationDetails] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState(null);


    useEffect(() => {
setbounce(true)
        var intCampusID=props.CampusID;
        // UserValidated
        const getData = async () => {
          const url = apiEndpoint+'/GetTodaysMaxSpeed';
        try {
        const response = await fetch(url, 
          { method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            "intCampusID": intCampusID,
            "strToken": sessionStorage.getItem("Clear_AuthUser")
          })
        });

         if(response.body!=null){
        const data = await response.json();
             // console.log(data)
             console.log("TODAY DETAILS:", data.ViolationDetails);
             settodaysMaxSpeed(data.MaxSpeed);
             setTodaysViolationDetails(data.ViolationDetails);
         }
      
         // UserValidated
      const urlMonth = apiEndpoint+'/GetMonthlyMaxSpeed';
     
      const responseMonthly =await fetch(urlMonth, { 
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          "intCampusID": intCampusID,
          "strToken": sessionStorage.getItem("Clear_AuthUser")
        })
      });
       if(responseMonthly.body!=null){
      const dataMonthly = await responseMonthly.json();
      //console.log(dataMonthly)
           setmonthlyMaxSpeed(dataMonthly.MaxSpeed);
           setMonthlyViolationDetails(dataMonthly.ViolationDetails);
       }

       // UserValidated
       const urlAvg = apiEndpoint+'/GetTodaysAvgSpeed';
     
      const responseAvg =await fetch(urlAvg,  {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          "intCampusID": intCampusID,
          "strToken": sessionStorage.getItem("Clear_AuthUser")
        })
      })  ;
       if(responseAvg.body!=null){
      const dataAvg = await responseAvg.json();
      //console.log(dataAvg)
      settodaysAvgSpeed(dataAvg.AvgSpeed);
       }
    } catch (error) {
        console.log(error);
    }
      };
        getData();
      }, [props.CampusID]);
    

 
if(props.type=="dailyMax"){
    speedoMeterProps=[
        {
            value: todaysMaxSpeed, 
            onClick: () => { setModalType("daily"); setShowModal(true); },
            maxValue:100,
            width:138,
            height:92,
            divHeight:"100%",
            divWidth:"100%",
            title:"Today's Highest Speed" }]
}
else if(props.type=="monthlyMax"){
    speedoMeterProps=[
        {
            value: monthlyMaxSpeed, 
            onClick: () => { setModalType("monthly"); setShowModal(true); },
            maxValue:100,
            width:138,
            height:92,
            divHeight:"100%",
            divWidth:"100%",
            title:"Monthly Highest Speed" }]
}
else if(props.type=="dailyAvg"){
    speedoMeterProps=[
        {  value: todaysAvgSpeed, 
            maxValue:100,
            width:256,
            height:175,
            divHeight:"100%",
            divWidth:"100%",
            title:"Today's Average Speed" }]
        }
  return (
    <React.Fragment>    
          {speedoMeterProps.map((param,key) => (
                <div  className={bounce ? 'bounce' : ''}  onAnimationEnd={() => setbounce(false)}>

                  
                  <Card className="mini-stat " onClick={() => param.onClick ? param.onClick() : null} style={{ display: 'flex', width: param.divWidth, justifyContent: 'center', alignItems: 'center', cursor: "pointer" }}>
  

    <CardBody  style={{ height:param.divHeight,minHeight:param.divHeight}}>     

    <h5 style={{width:param.divWidth}}>{param.title} </h5>
  <ReactSpeedometer forceRender={true}  value={param.value} maxValue={param.maxValue} needleTransition="easeQuadOut" 
  needleTransitionDuration={1000}width={param.width} height={param.height} startColor="rgb(106, 215, 45)" endColor="red"></ReactSpeedometer>
   </CardBody>  
  </Card>
  </div>
          ))}
          {showModal && (
              <div className="modal-overlay">
                  <div className="modal-box">
                      <h4>Violation Details</h4>

                      {/* DAILY VIOLATION DETAILS */}
                      {modalType === "daily" && TodaysViolationDetails && (
                          <>
                              <p><strong>Registration No:</strong> {TodaysViolationDetails.RegistrationNumber}</p>
                              <p><strong>Speed:</strong> {TodaysViolationDetails.VehicleSpeed}</p>
                              <p><strong>Location:</strong> {TodaysViolationDetails.LocationName}</p>
                              <p><strong>Incident Time:</strong> {TodaysViolationDetails.IncidentTime}</p>
                              <p><strong>Vehicle Owner:</strong> {TodaysViolationDetails.VehicleOwner || "N/A"}</p>
                              <p><strong>Email:</strong> {TodaysViolationDetails.Email || "Not Available"}</p>
                          </>
                      )}

                      {/* MONTHLY VIOLATION DETAILS */}
                      {modalType === "monthly" && monthlyViolationDetails && (
                          <>
                              <p><strong>Registration No:</strong> {monthlyViolationDetails.RegistrationNumber}</p>
                              <p><strong>Speed:</strong> {monthlyViolationDetails.VehicleSpeed}</p>
                              <p><strong>Location:</strong> {monthlyViolationDetails.LocationName}</p>
                              <p><strong>Incident Time:</strong> {monthlyViolationDetails.IncidentTime}</p>
                              <p><strong>Vehicle Owner:</strong> {monthlyViolationDetails.VehicleOwner || "N/A"}</p>
                              <p><strong>Email:</strong> {monthlyViolationDetails.Email || "Not Available"}</p>
                          </>
                      )}

                      <button className="btn btn-primary waves-effect waves-light"
                          onClick={() => setShowModal(false)}>
                          Close
                      </button>
                  </div>
              </div>
          )}
   </React.Fragment>
  )
  }
export default Speedometer
